module.exports = __webpack_public_path__ + "static/logo-711983a0189fa79882f4e3cbbc73c71f.svg";